<template>
  <footer class="footer">
    <a href="mailto:mouhcinedev@gmail.com">
      <img src="mail.svg" alt="" />
    </a>
    <p>Copyright &copy; {{ year }} Moroccan Truckers</p>
  </footer>
</template>

<script>

export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
  
};
</script>

<style>
.footer {
    padding: 3rem 0 1rem 0;
    text-align: center;
    margin-top: 3.5rem;
}

.footer img{
    width: 25px;
    height: 25px;
    transition: transform 0.3s;
    display: inline;
}

.footer img:hover {
    transform: translateY(-5px);
}

.footer p {
    font-size: 14px;
    margin: 0;
}

.footer p {
    font-weight: 600;
}

.footer p a {
    transition: color 0.3s;
    text-decoration: none;
}

.footer p a:hover {
    color: #444;
}
</style>